<div class="get-it-modal-dialog p-4" data-automation-id="get-it-modal-dialog">
  <app-modal-header
    title="{{ 'getThisItemDialogTitle' | translate }}"
    titleId="get-it-modal-title"
    closeId="close-get-it-dialog-btn"
    (close)="onClose()"
  >
  </app-modal-header>
  <div class="modal-body">
    <form [formGroup]="getItForm" class="get-it-form" (ngSubmit)="onSubmit()">
      <app-pickup-location-select
        formControlName="pickupLocation"
        [pickupLocations]="pickupLocations"
        [selectedLocationCode]="selectedLocationCode"
        (codeChanging)="changePickupLocation($event)"
        [dataAutomationId]="'pickupLocationDropdown'"
      >
      </app-pickup-location-select>
      <section class="actions mt-4">
        <button
          class="ins-buttons button-primary flint"
          type="submit"
          [disabled]="isFormDisabled || (this.isLoading$ | async)"
          data-automation-id="confirm-get-it-btn"
          translate
        >
          confirmLocation
        </button>
        <button
          type="button"
          class="ins-buttons button-secondary flint"
          (click)="onClose()"
          [disabled]="isLoading$ | async"
          data-automation-id="cancel-get-it-btn"
          translate
        >
          cancelCapitalized
        </button>
      </section>
    </form>
  </div>
</div>
